import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { connect } from "react-redux"
import { Tooltip } from "react-tooltip"
import dayjs from "dayjs"

import API from "../../../../api"
import { ROUTES } from "../../../../routes"
import { mapDispatchProps, mapStateToProps } from "../../../../store/store"
import { Tooltip as AntdTooltip } from "antd"

import Checkbox, { ICON_TYPES } from "../../../../components/checkbox"
import TextInputField from "../../../../components/textInput"
import Button from "../../../../components/button"
// screens
import CardCreate from "../../../../pages/cards/create"
import { debounce } from "lodash"
import { useLanguage } from "@languages/index"
import { loadStripe } from "@stripe/stripe-js"
import { Elements as StripeElements } from "@stripe/react-stripe-js"
import { Elements as MulpayElements } from "@mul-pay/mptoken-react-js"

const stripePromise = loadStripe(process.env.STRIPE_PUBLIC_KEY)

function useForceUpdate() {
  const [value, setValue] = useState(0)
  return () => setValue((value) => value + 1)
}

const RentalAmbassador = (props: any) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.rental }
  const forceUpdate = useForceUpdate()
  const navigate = useNavigate()

  const [mulpayPromise, setMulpayPromise] = useState<Promise<any> | null>(null);

  const [inputs, setInputs] = useState<any>({})
  const [isInfinityBudget, setIsInifinityBudget] = useState<any>(false)


  const handleInputChange = (key: string, value: any) => {
    const copy: any = { ...inputs }
    copy[`${key}`] = value || ""

    setInputs({ ...inputs, ...copy })
  }

  const budgetOptions = languageTexts._payments_budget_option(props.settings.currencyText)

    
  // MOUNT MULPAY
  useEffect(() => {
    let isMounted = true;
  
    const loadMulpayModule = async () => {
      try {
        const { loadMulpay } = await import('@mul-pay/mptoken-js');
        if (isMounted) {
          const apiKey = process.env.GMO_API_KEY
          const publicKey = process.env.GMO_PUBLIC_KEY
          const merchantIds = {
            // googlePayMerchantId: "01234567890123456789"
          }
          const promise = loadMulpay(apiKey, publicKey, undefined, true, true);
          setMulpayPromise(promise);
        }
      } catch (error) {
        console.error('Failed to load mulpay module', error);
      }
    };
  
    loadMulpayModule();
  
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let maxBudgetRentalText = "0"
    if (
      props.brand.maxBudgetRental &&
      props.brand.maxBudgetRental >= 10000 &&
      props.brand.maxBudgetRental <= 1000000000
    )
      // 10억 미만(그 이상은 무제한)
      maxBudgetRentalText = props.brand.maxBudgetRental.toString().slice(0, -4)
    setInputs({
      maxBudgetRental: maxBudgetRentalText || 0,
    })
    setIsInifinityBudget(props.brand.maxBudgetRental && props.brand.maxBudgetRental > 1000000000)
  }, [])

  const fetchBrand = () => {
    API.Brand.show({ brandToken: props.auth.token })
      .then((response) => {
        const _brand = response.data.brand
        props.setBrand(_brand)

        if (
          _brand.hasExperiencedInfoUpdate == false ||
          _brand.hasExperiencedAlarmUpdate == false ||
          response.data.brand.hasExperiencedPasswordUpdate == false
        ) {
          navigate(ROUTES.HELP_MISSIONS.PATH)
        }
      })
      .catch((error) => {})
  }

  const updateBrand = (params) => {
    API.Brand.update({
      brandToken: props.auth.token,
      ...params,
    })
      .then((response) => {
        let keys = Object.keys(params)
        if (keys.length === 1 && keys.indexOf("maxBudgetRental") >= 0) return
        props.showModal({ text: response.message })
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  const handleInputChangeBudgetOption = (option) => {
    const billingAmountThisMonth = props.brand.billingAmountThisMonth ? parseInt(props.brand.billingAmountThisMonth) : 0
    const input_value = option["name"].slice(0, -2)
    if (billingAmountThisMonth > option["value"]) {
      const moneyText = billingAmountThisMonth.toLocaleString()
      props.showModal({
        hideCloseButton: true,
        title: languageTexts.payments_text_1,
        text: languageTexts._payments_text_2(moneyText, option["name"], props.settings.currencyText),
        cancel: () => {},
        confirm: () => {
          handleInputChange("maxBudgetRental", input_value)
          setIsInifinityBudget(false)
        },
      })
    } else {
      handleInputChange("maxBudgetRental", input_value)
      setIsInifinityBudget(false)
    }
  }

  const renderCreateCardScreen = () => {
    const titleStyle = {
      fontWeight: 700,
      fontSize: "22px",
      lineHeight: "27px",
      letterSpacing: "-0.05em",
    }

    return (
      <div
        className="relative w-[100dvw] md:w-[480px] flex flex-col px-5 py-6 lg:p-8 bg-white overflow-scroll pb-[100px] md:pb-0 md:rounded-2xl"
        style={{
          minWidth: 370,
        }}
      >
        <div className="flex flex-col">
          <div className="flex flex-row mb-2">
            <span style={titleStyle}>{languageTexts.payments_text_3}</span>
          </div>
        </div>

        {(mulpayPromise != null && stripePromise != null) && (
          <MulpayElements multiPayment={mulpayPromise}>
            <StripeElements stripe={stripePromise}>
              <CardCreate
                onCardCreated={() => {
                  props.closeOverlays()
                  fetchBrand()
                }}
                onClose={() => {
                  props.closeOverlays()
                  fetchBrand()
                }}
              />
            </StripeElements>
          </MulpayElements>
        )}
      </div>
    )
  }

  const renderTooltip = (tooltipTagId, tooltipText, tooltipClassName) => {
    return (
      <>
        {!!tooltipText && !!tooltipTagId ? (
          <div>
            <img
              id={tooltipTagId}
              className={"w-[14px] h-[14px] ml-2"}
              src={`/assets/icons/ic-help-circle-black.svg`}
            />
            <Tooltip anchorSelect={"#" + tooltipTagId} className={tooltipClassName} place="top">
              <span className="text-[13px] py-1 whitespace-pre-wrap word-keep-all text-unset">{tooltipText}</span>
            </Tooltip>
          </div>
        ) : null}
      </>
    )
  }

  return (
    <div
      className="w-full flex flex-col items-center justify-center"
      style={{ paddingTop: props.preferences.headerHeight }}
    >
      <div className="flex flex-col w-full mx-auto max-w-[1024px] px-[20px] py-[80px]">
        <div className="flex flex-col">
          <span className="text-[36px] font-bold">{languageTexts.payment}</span>
        </div>

        <div className="h-[50px]" />

        <div className="flex flex-col w-full">
          <div className="flex flex-col">
            <div className="title flex flex-row items-center">
              <span className="text-[22px] font-bold">{languageTexts.payments_text_4}</span>
              {renderTooltip(
                "set-budget-tooltip",
                languageTexts._payments_text_5(props.settings.currencyText),
                "max-w-[600px]"
              )}
            </div>

            <div className="flex flex-row gap-[18px]">
              <div className="flex flex-row items-center gap-[50px]">
                <Checkbox
                  className={"min-w-[74px]"}
                  text={languageTexts.unlimited}
                  type={ICON_TYPES.CIRCLE}
                  checked={isInfinityBudget}
                  onClick={() => {
                    updateBrand({ maxBudgetRental: 1500000000 })
                    props.showModal({
                      hideCloseButton: true,
                      title: languageTexts.payments_text_6,
                      text: languageTexts.payments_text_7,
                      showCancelButton: false,
                    })
                    handleInputChange("maxBudgetRental", 0)
                    setIsInifinityBudget(true)
                  }}
                />
                <Checkbox
                  className={"min-w-[120px]"}
                  text={languageTexts.payments_text_8}
                  type={ICON_TYPES.CIRCLE}
                  checked={!isInfinityBudget}
                  onClick={() => {
                    if (!isInfinityBudget) return
                    handleInputChange("maxBudgetRental", 0)
                    setIsInifinityBudget(false)
                  }}
                />
              </div>
              <div className="flex flex-row w-full gap-[8px] items-center">
                <div className="flex flex-col w-full relative gap-[10px]">
                  <TextInputField
                    className="flex flex-row w-full h-[48px]"
                    bordered
                    textAlign={"right"}
                    placeholder={"0"}
                    value={inputs.maxBudgetRental}
                    onChangeText={(value) => {
                      let numericValue = value.replace(/[^0-9]/g, "")
                      const numV = parseInt(numericValue || 0)
                      if (numV > 100000)
                        // 10억
                        numericValue = "100000"
                      handleInputChange("maxBudgetRental", numericValue)
                    }}
                    unit={languageTexts._payments_text_9(props.settings.currencyText)}
                  />

                  <div
                    className="absolute flex flex-row w-full justify-between px-[4px]"
                    style={{
                      top: "calc(100% + 4px)",
                    }}
                  >
                    {budgetOptions.map((option) => {
                      return (
                        <div className="relative flex flex-row">
                          <span
                            className="underline underline-offset-2 cursor-pointer flex flex-row"
                            onClick={() => {
                              handleInputChangeBudgetOption(option)
                            }}
                          >
                            {option.name}
                          </span>

                          {option.name == budgetOptions[1].name ? (
                            <>
                              {renderTooltip(
                                "set-budget-recomendation-tooltip",
                                languageTexts._payments_text_34(props.settings.currencyText),
                                "max-w-[600px]"
                              )}
                              <div className="absolute left-1/2 top-5">
                                <AntdTooltip
                                  placement="bottom"
                                  title={<span className="px-2 text-[13px]">{languageTexts.payments_text_35}</span>}
                                  open={true}
                                  color="#000000"
                                  overlayInnerStyle={{
                                    borderRadius: "50px",
                                    marginTop: "-1px",
                                  }}
                                ></AntdTooltip>
                              </div>
                            </>
                          ) : null}
                        </div>
                      )
                    })}
                  </div>
                </div>

                <div className="w-[74px] h-[48px]">
                  <Button
                    className="border-unset w-full h-full flex items-center justify-center text-center"
                    text={languageTexts.save}
                    buttonColor={"black"}
                    textColor={"white"}
                    onClick={() => {
                      let v = 0
                      if (!inputs.maxBudgetRental || parseInt(inputs.maxBudgetRental) === 0) v = 0
                      else v = parseInt(`${inputs.maxBudgetRental}0000`)
                      updateBrand({ maxBudgetRental: v })

                      let sufix = languageTexts._payments_text_10(props.settings.currencyText)
                      if (v > 10000) sufix = languageTexts._payments_text_9(props.settings.currencyText)

                      props.showModal({
                        hideCloseButton: true,
                        title: languageTexts.payments_text_6,
                        text: languageTexts._payments_text_11(inputs.maxBudgetRental, sufix),
                        showCancelButton: false,
                      })
                      setIsInifinityBudget(false)
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="h-[140px]" />

        <BillingHistory
          {...props}
          targetDate={dayjs()}
          title={languageTexts.payments_text_12}
          titleTooltipId="payment-expected-title"
          titleTooltip={languageTexts.payments_text_13}
          titleTooltipAdditionalClassName="max-w-[600px]"
          renderTooltip={renderTooltip}
        />

        <div className="h-[50px]" />

        <BillingHistory {...props} title={languageTexts.payment_history2} arrows={true} renderTooltip={renderTooltip} />

        <div className="h-[50px]" />

        <div className="flex flex-col">
          <div className="flex flex-col gap-[15px]">
            <span className="text-[22px] font-bold">{languageTexts.payments_text_3}</span>

            <span className="text-[15px]">
              {props.brand.cards.length ? props.brand.cards[0].cardNumberMasked : languageTexts.payments_text_14}
            </span>

            {props.brand.cards.length ? (
              <div>
                <span
                  className="font-bold text-[15px] text-[#000000] cursor-pointer"
                  onClick={() => {
                    navigate(ROUTES.CARD_INDEX.PATH)
                  }}
                >
                  {languageTexts.payments_text_15}
                </span>
              </div>
            ) : (
              <div>
                <span
                  className="font-bold text-[15px] text-[#000000] cursor-pointer"
                  onClick={() => {
                    props.preferences.isMobile
                      ? props.setSheet({
                          isVisible: true,
                          maxHeight: "100%",
                          content: () => {
                            return renderCreateCardScreen()
                          },
                        })
                      : props.setModal({
                          isVisible: true,
                          maxHeight: "80dvh",
                          content: () => {
                            return renderCreateCardScreen()
                          },
                        })
                  }}
                >
                  {languageTexts.payments_text_3}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="ml-auto">
          <Button
            bordered
            className="px-[55px] py-[15px]"
            textClassName={"text-[15px]"}
            text={languageTexts.payments_text_16}
            onClick={() => {
              const month = dayjs().format("M")
              const money = props.brand.billingAmountWhenCancel
                ? parseInt(props.brand.billingAmountWhenCancel).toLocaleString()
                : 0

              let modal_text = languageTexts._payments_text_17(month, money, props.settings.currencyText)
              if (!money) {
                modal_text = languageTexts._payments_text_18(month)
              }

              props.showModal({
                hideCloseButton: true,
                content: () => {
                  return (
                    <div className="flex flex-col justify-center align-center p-8 bg-white">
                      <div className="content flex flex-col">
                        <span className="font-bold text-[22px] text-black">{languageTexts.payments_text_16}</span>
                        <div className="flex flex-col items-start py-4">
                          <span className="prose prose-md whitespace-pre-wrap leading-5 text-black">{modal_text}</span>
                        </div>
                      </div>
                      <div className="buttons flex flex-col rows-2 mt-3 gap-1.5">
                        <Button
                          className={"min-w-[10rem] py-3 flex justify-center text-center text-base"}
                          textColor={"WHITE"}
                          buttonColor={"BLACK"}
                          text={languageTexts.payments_text_19}
                          onClick={async () => {
                            try {
                              const response = await API.Brand.update({
                                brandToken: props.auth.token,
                                isAmbassadorServiceEnabled: "false",
                              })

                              setTimeout(() => {
                                let arr = {
                                  text: response.data.message,
                                }

                                if (response.data.title.length) {
                                  arr["title"] = response.data.title
                                }

                                props.showModal(arr)
                              }, 400)
                            } catch (error) {
                              props.showModal({
                                text: error?.data?.error ?? error.message,
                              })
                            }
                          }}
                        />
                        <Button
                          className={"min-w-[10rem] py-3 flex justify-center text-center text-base"}
                          borderColor={"BLACK"}
                          text={languageTexts.payments_text_20}
                          onClick={() => {
                            props.closeModal()
                            props.closeOverlays()
                          }}
                        />
                      </div>
                    </div>
                  )
                },
              })
            }}
          />
        </div>
      </div>
    </div>
  )
}

const BillingHistory = (props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.pages.rental }
  const [currentDate, setCurrentDate] = useState(props.targetDate ? props.targetDate : dayjs())

  const [billingAmountThisMonth, setBillingAmountThisMonth] = useState<any>(0)

  const [billingPaidAmountThisMonth, setBillingPaidAmountThisMonth] = useState<any>(0)

  const [pricePerRental, setPricePerRental] = useState<any>(0)
  const [pricePerRentalAmbassador, setPricePerRentalAmbassador] = useState<any>(0)

  const [normalBillingCreatingCount, setNormalBillingCreatingCount] = useState<any>(0)
  const [normalBillingCompletedCount, setNormalBillingCompletedCount] = useState<any>(0)
  const [normalBillingCreatingChargeAmount, setNormalBillingCreatingChargeAmount] = useState<any>(0)
  const [normalBillingCompletedChargeAmount, setNormalBillingCompletedChargeAmount] = useState<any>(0)
  const [ambassadorBillingCreatingCount, setAmbassadorBillingCreatingCount] = useState<any>(0)
  const [ambassadorBillingCompletedCount, setAmbassadorBillingCompletedCount] = useState<any>(0)
  const [ambassadorBillingCreatingChargeAmount, setAmbassadorBillingCreatingChargeAmount] = useState<any>(0)
  const [ambassadorBillingCompletedChargeAmount, setAmbassadorBillingCompletedChargeAmount] = useState<any>(0)

  useEffect(() => {
    setBillingAmountThisMonth(
      props.brand.billingAmountThisMonth ? parseInt(props.brand.billingAmountThisMonth).toLocaleString() : 0
    )
    setBillingPaidAmountThisMonth(
      props.brand.billingPaidAmountThisMonth ? parseInt(props.brand.billingPaidAmountThisMonth).toLocaleString() : 0
    )
  }, [props.brand])

  useEffect(() => {
    fetchBillingCounts()
  }, [currentDate])

  const fetchBillingCounts = (targetDate = null) => {
    if (!targetDate) targetDate = currentDate

    API.Billing.index({
      brandToken: props.auth.token,
      durationStart: currentDate.startOf("month").format("YYYY-MM-DD"),
      durationEnd: currentDate.endOf("month").format("YYYY-MM-DD"),
    })
      .then((response) => {
        setNormalBillingCreatingCount(parseInt(response.data.normalBillingCreatingCount).toLocaleString())

        setNormalBillingCompletedCount(parseInt(response.data.normalBillingCompletedCount).toLocaleString())

        setNormalBillingCreatingChargeAmount(parseInt(response.data.normalBillingCreatingChargeAmount).toLocaleString())

        setNormalBillingCompletedChargeAmount(
          parseInt(response.data.normalBillingCompletedChargeAmount).toLocaleString()
        )

        setAmbassadorBillingCreatingCount(parseInt(response.data.ambassadorBillingCreatingCount).toLocaleString())

        setAmbassadorBillingCompletedCount(parseInt(response.data.ambassadorBillingCompletedCount).toLocaleString())

        setAmbassadorBillingCreatingChargeAmount(
          parseInt(response.data.ambassadorBillingCreatingChargeAmount).toLocaleString()
        )

        setAmbassadorBillingCompletedChargeAmount(
          parseInt(response.data.ambassadorBillingCompletedChargeAmount).toLocaleString()
        )

        setPricePerRental(parseInt(response.data.normalBillingPrice).toLocaleString())
        setPricePerRentalAmbassador(parseInt(response.data.ambassadorBillingPrice).toLocaleString())

        setBillingAmountThisMonth(parseInt(response.data.billingAmountThisMonth).toLocaleString())
        setBillingPaidAmountThisMonth(parseInt(response.data.billingPaidAmountThisMonth).toLocaleString())
      })
      .catch((error) => {
        props.showModal({ text: error.message })
      })
  }

  const renderStatusTexts = (propsDate, currentDate) => {
    let paidStatusText = languageTexts.payments_text_21
    const isPaidStatusText = !propsDate
    const isPaid = dayjs() <= dayjs(props.brand.billingLastPaidAt)
    if (isPaidStatusText) paidStatusText = isPaid ? languageTexts.payments_text_22 : languageTexts.payments_text_23

    return (
      <>
        <span className="text-[15px]">{languageTexts._payments_text_24(currentDate.format("M"))}</span>
        <span className="text-[15px]">
          {languageTexts._payments_text_25(currentDate.add(1, "month").format("M"), paidStatusText)}
        </span>
      </>
    )
  }

  return (
    <div className="flex flex-col gap-[18px]">
      <div className="flex flex-row items-center">
        <span className="font-bold text-[22px]">{props.title}</span>
        {!props.titleTooltipId || !props.titleTooltip
          ? null
          : props.renderTooltip(props.titleTooltipId, props.titleTooltip, props.titleTooltipAdditionalClassName)}
      </div>

      <div className="flex flex-col border border[#E8E8E8] rounded-[10px] w-full py-[50px] gap-[40px]">
        {props.arrows ? (
          <div className="flex flex-row justify-center gap-[20px]">
            <div
              className="cursor-pointer"
              onClick={() => {
                setCurrentDate(currentDate.subtract(1, "month"))
              }}
            >
              <img src="/assets/icons/ic-arrow-left-circle-black.svg" />
            </div>
            <div>
              <span className="text-[22px] font-bold">{currentDate.format(languageTexts.date_format_month)}</span>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => {
                let hasNoNextMonth = !dayjs().isAfter(dayjs(currentDate), "month")
                if (hasNoNextMonth) return
                setCurrentDate(currentDate.add(1, "month"))
              }}
            >
              <img src="/assets/icons/ic-arrow-right-circle-black.svg" />
            </div>
          </div>
        ) : null}

        <div className="flex flex-col justify-center mx-auto gap-[10px]">
          <div className="flex flex-col text-center">{renderStatusTexts(props.targetDate, currentDate)}</div>

          <div className="flex flex-col mx-auto gap-[10px]">
            <div className="flex flex-col gap-[5px] items-center text-center">
              <div className="flex flex-row items-center">
                <span className="text-[22px] font-bold">{languageTexts.payments_text_26}</span>
                {props.renderTooltip(
                  `${props.titleTooltipId}-${currentDate.format("DD")}-tooltip`,
                  languageTexts.payments_text_27,
                  "max-w-[360px]"
                )}
              </div>
              <span className="text-[36px] font-bold">
                {languageTexts._price(billingAmountThisMonth, props.settings.currencyText)}
              </span>
            </div>

            <span className="text-center text-[13px] text-[#999999]">{languageTexts.payments_text_28}</span>
          </div>
        </div>

        <div className="flex flex-row max-w-[815px] mx-auto w-full">
          <div className="flex flex-1 flex-col itmes-center text-center gap-[25px]">
            <div className="text-center w-full">
              <span className="text-[22px] font-bold">{languageTexts.payments_text_29}</span>
            </div>
            <div className="flex flex-col gap-[36px]">
              <div className="flex flex-row justify-between max-w-[300px] w-full mx-auto">
                <div className="flex flex-col">
                  <span className="text-[15px] font-bold">{languageTexts.payments_text_30}</span>
                </div>
                <div className="flex flex-col gap-[5px] text-right">
                  <span className="text-[15px]">{languageTexts._payments_text_31(normalBillingCompletedCount)}</span>
                  <span className="text-[15px]">
                    {languageTexts._amount(normalBillingCompletedCount)}
                    {` * `}
                    {`${pricePerRental}${languageTexts._currency(
                      props.settings.currencyText
                    )} = ${normalBillingCompletedChargeAmount}${languageTexts._currency(props.settings.currencyText)}`}
                  </span>
                  <span className="text-[13px] text-[#999999]">{languageTexts.payments_text_28}</span>
                </div>
              </div>

              <div className="flex flex-row justify-between max-w-[300px] w-full mx-auto">
                <div className="flex flex-col">
                  <span className="text-[15px] font-bold">{languageTexts.payments_text_32}</span>
                </div>
                <div className="flex flex-col gap-[5px] text-right">
                  <span className="text-[15px]">{languageTexts._payments_text_31(normalBillingCreatingCount)}</span>
                  <span className="text-[15px]">
                    {languageTexts._amount(normalBillingCreatingCount)}
                    {` * `}
                    {`${pricePerRental}${languageTexts._currency(
                      props.settings.currencyText
                    )} = ${normalBillingCreatingChargeAmount}${languageTexts._currency(props.settings.currencyText)}`}
                  </span>
                  <span className="text-[13px] text-[#999999]">{languageTexts.payments_text_28}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-1 flex-col itmes-center text-center gap-[25px]">
            <div className="text-center w-full">
              <span className="text-[22px] font-bold">{languageTexts.payments_text_33}</span>
            </div>

            <div className="flex flex-col gap-[36px]">
              <div className="flex flex-row justify-between max-w-[300px] w-full mx-auto">
                <div className="flex flex-col">
                  <span className="text-[15px] font-bold">{languageTexts.payments_text_30}</span>
                </div>
                <div className="flex flex-col gap-[5px] text-right">
                  <span className="text-[15px]">
                    {languageTexts._payments_text_31(ambassadorBillingCompletedCount)}
                  </span>
                  <span className="text-[15px]">
                    {languageTexts._amount(ambassadorBillingCompletedCount)}
                    {` * `}
                    {`${pricePerRentalAmbassador}${languageTexts._currency(
                      props.settings.currencyText
                    )} = ${ambassadorBillingCompletedChargeAmount}${languageTexts._currency(
                      props.settings.currencyText
                    )}`}
                  </span>
                  <span className="text-[13px] text-[#999999]">{languageTexts.payments_text_28}</span>
                </div>
              </div>

              <div className="flex flex-row justify-between max-w-[300px] w-full mx-auto">
                <div className="flex flex-col">
                  <span className="text-[15px] font-bold">{languageTexts.payments_text_32}</span>
                </div>
                <div className="flex flex-col gap-[5px] text-right">
                  <span className="text-[15px]">{languageTexts._payments_text_31(ambassadorBillingCreatingCount)}</span>
                  <span className="text-[15px]">
                    {languageTexts._amount(ambassadorBillingCreatingCount)}
                    {` * `}
                    {`${pricePerRentalAmbassador}${languageTexts._currency(
                      props.settings.currencyText
                    )} = ${ambassadorBillingCreatingChargeAmount}${languageTexts._currency(
                      props.settings.currencyText
                    )}`}
                  </span>
                  <span className="text-[13px] text-[#999999]">{languageTexts.payments_text_28}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(RentalAmbassador)
